// src/modules/app-views/_apps/appmulti/orders/pages/Init/actions/actionButton.js
// *******************************************************************************
// ACTION BUTTON — Orders are created by checkout, never from the list.
// Returns null (no primary new-document button).
// *******************************************************************************
const ordersInitActionButton = () => null;

export default ordersInitActionButton;
